import * as R from 'ramda';

export const getFeature = R.pipe(R.propOr([], 'features'), R.pluck('feature'));
